import React, { useState } from "react";
import AddButton from "@core/buttons/atoms/AddButton";
import AddModal from "@core/modals/AddModal";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import FleetSegmentationService from "@services/FleetSegmentationService";

const CreateFleetSegmentation = ({ onAdded }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [alphaCode, setAlphaCode] = useState("");

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setDescription("");
    setEnglishName("");
    setAlphaCode("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    FleetSegmentationService.create(name, englishName, description, alphaCode)
      .then(() => {
        showSuccess(t("fleetSegmentationsCreatedSuccessfully"));
        closeModal();
        onAdded();
        setShowModal(false);
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"view_fleet_segmentations"}>
      <AddButton
        label={t("addFleetSegmentations")}
        onClick={() => setShowModal(true)}
      />
      <AddModal
        show={showModal}
        title={t("addFleetSegmentation")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <Input
            height="h-10"
            label={t("alphaCode")}
            placeholder={t("alphaCode")}
            value={alphaCode}
            onChange={setAlphaCode}
          />
        </div>
      </AddModal>
    </PermissionHandler>
  );
};

export default CreateFleetSegmentation;
